import React, { type FC, type ReactNode } from 'react';
import classNames from 'classnames';

import styles from './PersonalWidget.module.scss';

export type PersonalWidgetProps = {
  title: string;
  children: ReactNode;
  divider?: boolean;
  className?: string;
};

export const PersonalWidget: FC<PersonalWidgetProps> = ({
  children,
  title,
  divider = false,
  className,
}) => {
  const contentClassnames = classNames(styles.content, {
    [styles.divider]: divider,
  }, className);

  return (
    <>
      {title && (
        <h5 className={styles.title}>{title}</h5>
      )}
      {children && (
        <div className={contentClassnames}>{children}</div>
      )}
    </>
  );
};
